import api from '../../api';

export interface AudienceAssignment {
  from?: string;
  to?: string;
  repeatable: boolean;
  timezone: string;
  id?: string;
}

export interface GroupAudience {
  schoolId: string;
  groupId: string;
  audienceType: 'group';
  assignment?: AudienceAssignment;
  dateError?: boolean;
}

export interface MemberAudience {
  schoolId: string;
  groupId: string;
  userId: string;
  audienceType: 'member';
  assignment?: AudienceAssignment;
  dateError?: boolean;
}

export interface SchoolAudience {
  schoolId: string;
  audienceType: 'school' | 'smartschoolschool';
  assignment?: AudienceAssignment;
}

export interface UserSharedMaterial {
  id: string;
  moduleId: string;
  nodeId: string;
  materialType: string;
  materialId: string | number;
  audiences: (Audience | SchoolAudience)[];
}

export interface SharedMaterialData {
  userMaterials?: string[];
  slideSets?: number[];
  mediaLinks?: string[];
}

export type Audience = GroupAudience | MemberAudience;

export const isSchoolAudience = (audience: Audience | SchoolAudience): audience is SchoolAudience =>
  audience.audienceType === 'school' || audience.audienceType === 'smartschoolschool';

export const postSharedMaterials = async (
  moduleId: string,
  nodeId: string,
  audiences: Audience[],
  materials: SharedMaterialData,
) => {
  const { data } = await api.post(`studio/user/modules/${moduleId}/table-of-content/${nodeId}/shared-material/bulk`, {
    audiences,
    material: materials,
  });

  return data;
};

export const deleteSharedMaterials = async (moduleId: string, nodeId: string, materials: SharedMaterialData) => {
  const { data } = await api.post(
    `studio/user/modules/${moduleId}/table-of-content/${nodeId}/shared-material/bulk-delete`,
    {
      material: materials,
    },
  );

  return data;
};

// Retrieves the sharedMaterial when sharing a single material
export const getInitialSingleSharedMaterial = async (moduleId: string, nodeId: string, materialId: string | number) => {
  const { data } = await api.get<UserSharedMaterial>(
    `studio/user/modules/${moduleId}/table-of-content/${nodeId}/shared-material/${materialId}/info`,
  );
  return data;
};

// Updates the sharedMaterial when sharing a single material which is already shared
export const putSingleSharedMaterial = async (usm: UserSharedMaterial) => {
  const { data } = await api.put<UserSharedMaterial>(
    `studio/user/modules/${usm.moduleId}/table-of-content/${usm.nodeId}/shared-material/${usm.materialId}/info/${usm.id}`,
    {
      materialType: usm.materialType,
      audiences: usm.audiences,
    },
  );
  return data;
};
